import AntdEmpty from 'antd/lib/empty';
import React     from 'react';

type EmptyProps = {
	description?: React.ReactNode;
	style?: React.CSSProperties;
}

const Empty = (props: EmptyProps) => {
	return (
		<AntdEmpty
			description={props.description}
			style={props.style}
		/>
	);
};

export default Empty;
